var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-smart-slider-pips" },
    _vm._l(_vm.marker, function (singleMarker) {
      return _c("vue-smart-slider-pip", {
        key: singleMarker.id,
        attrs: {
          "marker-count": _vm.marker.length,
          marker: singleMarker,
          width: _vm.width,
          max: _vm.max,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }